import React from 'react'
import styles from './svg.module.scss'

const SearchOutline = ({
  viewBox = '0 0 24 24',
  size = 24,
  color = 'primaryColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={styles[`${color}Stroke`]}
      style={{ fill: 'none' }}
    >
      <path d="m21 21-4.34-4.34" />
      <circle cx="11" cy="11" r="8" />
    </svg>
  )
}

export default SearchOutline
